// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"771f9441","732":"87aebb3f","977":"579fd037"}[chunkId] + ".chunk.js";
};